import { Alert, Box, CircularProgress, IconButton, Stack, Tooltip, Typography } from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import { useState } from "react";

import { useAuth } from "../context/AuthContext";
import downloadCaCertificate from "../utils/downloadCaCertificate";

const ClientSecurityForm = () => {
  const { authorizedFetch } = useAuth();
  const [downloading, setDownloading] = useState(false);
  const [downloadError, setDownloadError] = useState<string | null>(null);

  const handleDownload = async () => {
    setDownloadError(null);
    setDownloading(true);
    try {
      await downloadCaCertificate(authorizedFetch);
    } catch (error) {
      setDownloadError(error instanceof Error ? error.message : "Unable to download certificate");
    } finally {
      setDownloading(false);
    }
  };

  return (
    <Stack spacing={2}>
      <Typography variant="body2" color="text.secondary">
  Install the CA certificate on each device if you serve SkyView over a locally issued HTTPS certificate. This step
        allows the PWA and push notifications to trust the server.
      </Typography>
      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
          Download CA Certificate
        </Typography>
        <Tooltip title="Download the CA certificate configured on the server">
          <span>
            <IconButton
              aria-label="Download CA certificate"
              onClick={() => {
                void handleDownload();
              }}
              disabled={downloading}
              size="small"
            >
              {downloading ? <CircularProgress size={16} /> : <DownloadIcon fontSize="small" />}
            </IconButton>
          </span>
        </Tooltip>
      </Box>
      {downloadError && <Alert severity="error">{downloadError}</Alert>}
    </Stack>
  );
};

export default ClientSecurityForm;
